import React from "react";
import { A } from "hookrouter";
import { useGenres } from "../Browse/GenreHooks";
import styles from "./Navbar.module.css";
import { FaChevronDown } from "react-icons/fa";

const NavbarLinks = () => {
  const { genres } = useGenres();
  const [dropdown, setDropdown] = React.useState(false);
  const [preGenres, setPreGenres] = React.useState([]);
  const num = () => Math.floor(Math.random() * genres.length);

  React.useEffect(() => {
    if (genres.length > 0 && preGenres.length === 0) {
      setPreGenres([genres[num()], genres[num()]]);
    }
  }, [genres]);

  return (
    <div className={styles.links}>
      <li>
        <h6
          onClick={() => setDropdown(!dropdown)}
          className={styles.dropdownTrigger}
        >
          Browse <FaChevronDown />
        </h6>
        {dropdown && (
          <Dropdown items={genres} closeDropdown={() => setDropdown(false)} />
        )}
      </li>
      {preGenres.map((genre) => (
        <li key={genre.genreName}>
          <A href={`/browse/genre/${genre.genreName}`}>
            <h6>{genre.genreName}</h6>
          </A>
        </li>
      ))}
    </div>
  );
};

const Dropdown = ({ items, closeDropdown }) => (
  <div className={styles.dropdown} onClick={closeDropdown}>
    {Array.from(Array(Math.ceil(items.length / 10))).map((_, i) => (
      <div className={styles.column}>
        {items.slice(10 * i, 10 * (i + 1)).map((item) => (
          <li key={item.genreName}>
            <A href={`/browse/genre/${item.genreName}`}>
              <span>{item.genreName}</span>
            </A>
          </li>
        ))}
      </div>
    ))}
  </div>
);

export default NavbarLinks;
